import * as yup from "yup";

const PermitsFeesSchema = yup.object().shape({
  "name": yup.string().required(),
  "fee-type": yup.string().required(),
  "general-ledger": yup.string().optional().max(100, "General Ledger can't be more than 100 characters"),
});

export default PermitsFeesSchema;
